import isBehind from "./isBehind";

export default function withScoreLessThanDecorator({ percentile, metric, grade, displayedString, locale }) {
  if(isBehind(percentile, metric, grade, locale)) return `≤ ${displayedString}`;
  return displayedString;
}